import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { MediaDTO } from '../../dto/MediaDto';
import { MaterialDTO } from '../../dto/MaterialDTO';
import { MaterialCategoryDTO } from '../../dto/MaterialCategoryDTO';
import { OptionsType } from '../../components/filterTypes/multiselectbox/types';

export interface FilterSlice {
    filterResistanceType: string[];
    materialCategoryFilter: MaterialCategoryDTO[] | OptionsType;
    materialFilter: MaterialDTO[] | OptionsType;
    mediaFilter: MediaDTO[] | OptionsType;
}

const initialState: FilterSlice = {
    filterResistanceType: [],
    materialCategoryFilter: [],
    materialFilter: [],
    mediaFilter: []
}

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        addFilters(state, action: PayloadAction<FilterSlice>) {
            state.filterResistanceType = action.payload.filterResistanceType;
            state.materialCategoryFilter = action.payload.materialCategoryFilter;
            state.materialFilter = action.payload.materialFilter;
            state.mediaFilter = action.payload.mediaFilter;
        },
    },
});

export const { addFilters } = filterSlice.actions;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getFilters = (state: RootState) => state.filter;

export default filterSlice.reducer;